import React from 'react';
import { useTranslation } from 'react-i18next';

import { DeleteIcon } from '@vlabs/icons';
import { STREAM_STATUSES } from '@vlabs/pages/video-analytics/constants';
import { Control } from '@vlabs/uikit';
import cn from 'classnames';

import st from './AnalyticSectionHeader.module.sass';

export const AnalyticSectionHeader = ({ label, status, onDelete }) => {
  const { t } = useTranslation();

  return (
    <div className={st.Root}>
      <div className={st.Title}>
        <h6>{label}</h6>
        {status >= 0 && (
          <span className={cn(st.Status, st[`StatusColors_${STREAM_STATUSES[status]?.label}`])}>
            <span aria-hidden className={st.StatusDot} />
            <span>{t(`videoAnalytics:request_status.${STREAM_STATUSES[status]?.label}`, { defaultValue: '' })}</span>
          </span>
        )}
      </div>
      <Control.Button icon={<DeleteIcon />} kind="negative" onClick={onDelete} size="small" variant="flat">
        {t('videoAnalytics:form.delete button')}
      </Control.Button>
    </div>
  );
};
